import { FormItem } from '../../../../../commons/Form/Form.types';
import { ProfilePasswordFormSchema } from './ProfilePasswordForm.types';

export const profilePasswordData: FormItem<ProfilePasswordFormSchema>[][] = [
  [
    {
      name: 'currentPassword',
      placeholder: 'Votre mot de passe actuel...',
      label: 'Mot de passe actuel',
      type: 'password',
      required: true,
    },
  ],
  [
    {
      name: 'password',
      placeholder: 'Votre nouveau mot de passe...',
      label: 'Nouveau mot de passe',
      type: 'password',
      required: true,
    },
    {
      name: 'passwordConfirmation',
      placeholder: 'Confirmez votre nouveau mot de passe...',
      label: 'Confirmation du nouveau mot de passe',
      type: 'password',
      required: true,
    },
  ],
];
